import { bootstrap } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { disableDeprecatedForms, provideForms } from '@angular/forms';
import { HTTP_PROVIDERS } from '@angular/http';
import { AppComponent } from './app/app.component';
import { APP_ROUTER_PROVIDERS } from './app/app.routes';
// import { APP_ROUTERR_PROVIDERS } from './app/Home/home.routes';

// import  { LoginComponent } from './app/AuthModule/login.component'
if (process.env.ENV === 'production') {
  enableProdMode();
}

// bootstrap(AppComponent, [HTTP_PROVIDERS]);
// bootstrap(LoginComponent, []);
bootstrap(AppComponent, [HTTP_PROVIDERS,
  disableDeprecatedForms(),
  provideForms(),
  APP_ROUTER_PROVIDERS, 
  // APP_ROUTERR_PROVIDERS
]);


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/main.ts
 **/